import { useState } from 'react';
import { useAuth } from '../AuthContext';
import './HostAccessModal.css';

const HostAccessModal = ({ isOpen, onClose, onSuccess }) => {
  const { grantHostAccess } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    const success = await grantHostAccess(password);
    if (success) {
      onSuccess();
      onClose();
    } else {
      setError('Incorrect access code. Please try again.');
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="host-modal-overlay" onClick={onClose}>
      <div className="host-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="host-modal-close" onClick={onClose}>
          &times;
        </button>

        <div className="host-modal-header">
          <h2>Want to host? We love that energy.</h2>
          <p>During our launch, hosting is reserved for folks who've already shared a meal with us — because the best communities are built on real trust. Attend a SatSat dinner, pass the vibe check, and you'll get the keys to your own table. 🍽️</p>
        </div>

        <form onSubmit={handleSubmit} className="host-modal-form">
          <div className="host-modal-input-group">
            <label htmlFor="hostPassword">Access Code</label>
            <input
              type="password"
              id="hostPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter access code"
              autoFocus
              disabled={isSubmitting}
            />
          </div>

          {error && <p className="host-modal-error">{error}</p>}

          <button
            type="submit"
            className="host-modal-submit"
            disabled={isSubmitting || !password}
          >
            {isSubmitting ? 'Verifying...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default HostAccessModal;
